<template>
  <div class="card">
    <div class="card-header"><h2 style="font-size: 22px;">Attestation</h2></div>
    <div class="card-body">
      <b-row class="mb-3">
      </b-row>
      <b-row class="mt-3">
        <b-col>
            Any person who obtains vital record data without authority, by knowingly and willfully giving false information, or with the intent to deceive, may be charged with a crime and may face jail time and fines. Any person who uses a vital record fraudulently may be charged with a crime, be fined, and face jail time. (<a href="https://www.revisor.mn.gov/statutes/cite/144.227" class="mdh-green-link" target="_blank">Minnesota Statutes, Section 144.227 - opens in new tab</a>).
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          By signing my name in the space below, I hereby attest that the information I am providing on this electronic application is correct to the best of my knowledge and
          belief<span v-if="affirmation">, and {{this.affirmation}}</span><span v-else>.</span>
        </b-col>
      </b-row>
      <b-row v-if="hasMfarProduct" class="mt-3">
          <b-col>
            I certify that the information above is complete and accurate and that I have the authority to request a search and get results according to <a href="https://www.revisor.mn.gov/statutes/cite/259.52" class="mdh-green-link" target="_blank">Minnesota Statutes, section 259.52, subdivision 2 - opens in new tab</a>.
          </b-col>
      </b-row>
      <b-row v-if="relationshipAttorney && hasMfarProduct" class="mt-3">
        <b-col>
          AFFIDAVIT: I am a licensed attorney who represents the birth mother, legal father, or prospective adoptive parents, and I am entitled to search the Minnesota Fathers’ Adoption Registry. I declare under penalty of perjury that everything I have stated in this document is true and correct.
        </b-col>
      </b-row>
      <div v-if="relationshipAttorney && hasMfarProduct">
        <b-row>
          <b-col class="font-weight-bold">Signed In:</b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <BaseTextInput v-model="county"
                           :v="$v.county"
                           slug="signCounty"
                           label="County"
                           maxLength="100"
            />
          </b-col>
          <b-col md="6">
            <BaseSelector v-model="state"
                          :v="$v.state"
                          label="State"
                          slug="signState"
                          :options=opts.stateOptions
            />
          </b-col>
        </b-row>
      </div>
      <b-row class="mt-3">
        <b-col cols="12" md="6">
          <BaseTextInput v-model="signature"
                         :v="$v.signature"
                         slug="signature"
                         label="Signature"
                         setId="sig2"
          />
        </b-col>
        <b-col cols="12" md="6">
          <BaseDateInput v-model="dateSigned"
                         :v="$v.dateSigned"
                         label="Today's Date"
                         slug="dateSigned"
                         :disabled="true"
                         setId="dtSig"
                         aria-disabled="true"
          />
        </b-col>
      </b-row>
    </div>
  </div>

</template>
<script>
import BaseTextInput from '@/components/templates/input/BaseTextInput.vue'
import BaseDateInput from '@/components/templates/input/BaseDateInput.vue'
import {required, requiredIf} from 'vuelidate/lib/validators'
import axios from "axios"
import axiosRetry from 'axios-retry'
import LocalStorageService from "@/common/LocalStorageService";
import {commonOptions} from "@/mixins/commonOptions";

axiosRetry(axios, { retries: 3,
  retryDelay: axiosRetry.exponentialDelay  })

const localStorageService = LocalStorageService.getService();

export default {
  data: () => {
    return {
      signature: null,
      relationshipAttorney: false,
      affirmation: "",
      dateSigned: new Date().toISOString().slice(0,10),
      state: null,
      county: null,
    }
  },
  props: {
    products: [Array],
  },
  components: {
    BaseTextInput,
    BaseDateInput
  },
  mixins: [
    commonOptions,
  ],
  validations() {
    return {
      signature:{ required },
      dateSigned: { required },
      state: {
        required: requiredIf(function() {
          return this.relationshipAttorney && this.hasMfarProduct
        })
      },
      county: {
        required: requiredIf(function() {
          return this.relationshipAttorney && this.hasMfarProduct
        })
      },
      form: [ 'signature','dateSigned', 'state', 'county' ]
    }
  },
  mounted() {
    this.orderNumber = localStorageService.getOrderNumber()
    this.relationshipIncludesAttorney()
    this.loadAffirmation()
  },
  computed: {
    hasMfarProduct() {
      return this.products.length > 0 && this.products.filter(p => p.category === "MFAR").length > 0
    },
  },
  methods: {
    relationshipIncludesAttorney() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/affirm/attorney/${this.orderNumber}`)
          .then(response => {
            this.relationshipAttorney = response.data;
          })
    },
    loadAffirmation() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/affirm/affirmationText/${this.orderNumber}`)
          .then(response => {
            this.affirmation = response.data;
          })
    },
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid)
      return isValid
    },
  }
}
</script>
